// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  accAnnounceMovedKey: (p: { itemKey: string; position: string; referenceKey: string }) =>
    p['itemKey'] + ' ' + p['position'] + ' ' + p['referenceKey'] + ' dialihkan.',
  accButtonProgressComplete: (p: { label: string }) => 'Tindakan ' + p['label'] + ' selesai',
  accButtonProgressStatus: (p: { label: string }) => 'Tindakan ' + p['label'] + ' sedang berjalan',
  accColorPalette: () => 'Palet Warna',
  accColorSwatch: () => 'Reja Warna',
  accCommandKey: () => 'Perintah',
  accContextMenuLabel: () => 'tindakan',
  accControlKey: () => 'Tutup',
  accPositionAfter: () => 'selepas',
  accPositionBefore: () => 'sebelum',
  accReorderInstructions: (p: { keyPressed: string }) =>
    'Tekan dan tahan ' +
    p['keyPressed'] +
    ' dan kekunci shift, kemudian gunakan kekunci anak panah untuk menyusun semula.',
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    'Masukkan tarikh yang lengkap seperti ini: ' + p['dateExample'] + '.',
  calendarMonthConverter_parseError: (p: { dateExample: string }) =>
    'Masukkan bulan dan tahun seperti ini: ' + p['dateExample'] + '.',
  chart_labelDataLabel: () => 'Label',
  chart_labelGroup: () => 'Kumpulan',
  chart_labelSeries: () => 'Siri',
  chart_labelValue: () => 'Nilai',
  chart_labelWidthWeight: () => 'Z',
  chart_labelX: () => 'X',
  chart_labelY: () => 'Y',
  checkboxSet_requiredMessageDetail: () => 'Pilih nilai.',
  checkbox_helpForCheckbox: () => 'Bantuan untuk kotak semak',
  checkbox_requiredMessageDetail: () => 'Pilih nilai.',
  checkbox_selected: () => 'Kotak semak ditanda',
  checkbox_unselected: () => 'Kotak semak tidak ditanda',
  close: () => 'Tutup',
  collection_apply: () => 'Gunakan',
  collection_cancel: () => 'Batalkan',
  collection_loaded: () => 'Dimuatkan',
  collection_loading: () => 'Memuatkan',
  collection_noData: () => 'Tiada data untuk dipaparkan.',
  collection_pixels: () => 'piksel',
  collection_resizeColumnDialog: () => 'Ubah saiz lajur',
  collection_resizeColumnMenu: () => 'Ubah Saiz Lajur...',
  collection_resizeMessageDetail: (p: { MIN: string; MAX: string }) =>
    'Masukkan nombor antara ' + p['MIN'] + ' hingga ' + p['MAX'] + '.',
  collection_selectAllRows: () => 'Pilih semua baris',
  collection_selectRow: (p: { ROW_NAME: string }) => 'Pilih baris ' + p['ROW_NAME'],
  collection_sortAscendingSubMenu: () => 'Menaik',
  collection_sortColumnMenu: () => 'Isih Lajur',
  collection_sortDescendingSubMenu: () => 'Menurun',
  collection_sortDisabled: () => 'Tidak boleh diisih',
  collection_sortEnabled: () => 'Boleh diisih',
  collection_width: () => 'Lebar',
  colorPicker_label: () => 'Pemilih Warna',
  confirmation: () => 'Pengesahan',
  datePicker_currentDate: () => 'Tarikh semasa',
  datePicker_goToToday: () => 'Pergi ke hari ini',
  datePicker_label: () => 'Pemilih Tarikh',
  datePicker_month: () => 'Bulan',
  datePicker_months: () => 'Bulan',
  datePicker_next: () => 'Seterusnya',
  datePicker_nextDecade: () => 'Dekad seterusnya',
  datePicker_nextMonth: () => 'Bulan seterusnya',
  datePicker_prev: () => 'Sebelumnya',
  datePicker_prevDecade: () => 'Dekad sebelumnya',
  datePicker_prevMonth: () => 'Bulan sebelumnya',
  datePicker_restricted: () => 'Dihadkan',
  datePicker_selected: () => 'Dipilih',
  datePicker_today: () => 'Hari ini',
  datePicker_weekNum: (p: { NUM: string }) => 'Minggu ' + p['NUM'],
  datePicker_weekNumColLabel: () => 'Nombor Minggu',
  datePicker_year: () => 'Tahun',
  datePicker_years: () => 'Tahun',
  diagram_promotedLink: () => '1 pautan',
  diagram_promotedLinkAriaDesc: () => 'Tidak langsung',
  diagram_promotedLinks: (p: { num_links: string }) => p['num_links'] + ' pautan',
  error: () => 'Ralat',
  expandableList_expandCollapseInstructionText: () =>
    'Gunakan anak kekunci untuk kembangkan dan runtuhkan',
  expandableList_groupCollapse: () => 'Diruntuhkan',
  expandableList_groupExpand: () => 'Dikembangkan',
  filePicker_addFiles: () => 'Tambah Fail',
  filePicker_dropzonePrimaryText: () => 'Seret dan Lepaskan',
  filePicker_dropzoneSecondaryText: () => 'Pilih fail atau lepaskan satu fail di sini',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Pilih atau lepaskan fail di sini',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Anda tidak boleh memuat naik fail jenis: ' + p['fileTypes'],
  filePicker_singleFileUploadError: () => 'Muat naik satu fail pada satu-satu masa',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Anda tidak boleh memuat naik fail jenis ' + p['fileType'],
  filePicker_unknownFileTypeUploadError: () => 'tidak diketahui',
  formControl_clear: () => 'Kosongkan',
  formControl_day: () => 'Hari',
  formControl_empty_segment: () => 'Kosong',
  formControl_helpAvailable: () => 'Bantuan tersedia',
  formControl_hide: () => 'Sembunyikan',
  formControl_hour: () => 'Jam',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    'Anda telah mencapai had sebanyak ' +
    ((
      { one: new Intl.NumberFormat('ms').format(p['CHARACTER_LIMIT']) + '-character' } as Partial<
        Record<Intl.LDMLPluralRule, string>
      >
    )[new Intl.PluralRules('ms').select(p['CHARACTER_LIMIT'])] ||
      new Intl.NumberFormat('ms').format(p['CHARACTER_LIMIT']) + '-character') +
    '.',
  formControl_loading: () => 'Memuatkan',
  formControl_maxLength: (p: { MAX_LENGTH: string }) =>
    'Anda boleh memasukkan hingga ' + p['MAX_LENGTH'] + ' aksara.',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Panjang maksimum ' + p['MAX_LENGTH'] + ' dicapai.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + ' aksara lagi.',
  formControl_millisecond: () => 'Milisaat',
  formControl_minute: () => 'Minit',
  formControl_month: () => 'Bulan',
  formControl_readOnly: () => 'Baca sahaja',
  formControl_requiredMessageDetail: () => 'Masukkan nilai.',
  formControl_second: () => 'Saat',
  formControl_selectionExactMessageDetail: (p: { n: string }) => 'Pilih ' + p['n'] + ' nilai.',
  formControl_selectionOverflowMessageDetail: (p: { max: string }) =>
    'Anda telah mencapai had pilihan sebanyak ' + p['max'] + '.',
  formControl_selectionRangeMessageDetail: (p: { min: string; max: string }) =>
    'Pilih ' + p['min'] + ' hingga ' + p['max'] + ' nilai.',
  formControl_selectionUnderflowMessageDetail: (p: { min: string }) =>
    'Pilih sekurang-kurangnya ' + p['min'] + ' nilai.',
  formControl_show: () => 'Papar',
  formControl_year: () => 'Tahun',
  gantt_labelDate: () => 'Tarikh',
  gantt_labelEnd: () => 'Tamat',
  gantt_labelLabel: () => 'Label',
  gantt_labelRow: () => 'Baris',
  gantt_labelStart: () => 'Mula',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Tiada seksyen yang sepadan ditemui.',
  indexer_keyboardInstructionText: () => 'Tekan Enter untuk memilih nilai.',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Antara ' + p['FROM_SECTION'] + ' dengan ' + p['TO_SECTION'] + '.',
  indexer_touchInstructionText: () =>
    'Ketik dua kali dan tahan untuk memasuki mod gerak isyarat, kemudian seret ke atas atau ke bawah untuk melaraskan nilai.',
  info: () => 'Maklumat',
  inputColor_selectColor: () => 'Pilih warna',
  inputDateMask_date_cleared: () => 'Tarikh dikosongkan',
  inputDateMask_dayPlaceholder: () => 'hh',
  inputDateMask_empty_segment: () => 'Kosong',
  inputDateMask_monthPlaceholder: () => 'bb',
  inputDateMask_yearPlaceholder: () => 'tttt',
  inputDatePicker_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Masukkan tarikh yang adalah pada atau sebelum ' + p['max'] + '.',
  inputDatePicker_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Masukkan tarikh yang adalah pada atau selepas ' + p['min'] + '.',
  inputDatePicker_dateRestrictionMessageDetail: () => 'Masukkan tarikh yang tersedia.',
  inputDatePicker_instruction: () => 'Tekan Tab untuk mengakses kalendar.',
  inputDatePicker_selectDate: () => 'Pilih tarikh',
  inputMonthMask_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Masukkan bulan dan tahun pada atau sebelum ' + p['max'] + '.',
  inputMonthMask_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Masukkan bulan dan tahun pada atau sebelum ' + p['min'] + '.',
  inputNumber_converterParseError: () => 'Masukkan nombor.',
  inputNumber_decrease: () => 'Kurangkan',
  inputNumber_increase: () => 'Tambahkan',
  inputPassword_hidden: () => 'Kata Laluan Disembunyikan',
  inputPassword_hide: () => 'Sembunyikan Kata Laluan',
  inputPassword_show: () => 'Tunjukkan Kata Laluan',
  inputSensitiveText_hidden: () => 'Teks sensitif disembunyikan',
  inputTimeMask_timeRangeOverflowMessageDetail: (p: { max: string }) =>
    'Masukkan masa yang merupakan ' + p['max'] + ' atau lebih awal.',
  inputTimeMask_timeRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Masukkan nombor yang merupakan ' + p['min'] + ' atau kemudian.',
  inputTimeMask_time_cleared: () => 'Masa dikosongkan',
  labelNone: () => 'Tiada',
  list_msgFetchCompleted: () => 'Dimuatkan',
  list_msgFetchingData: () => 'Memuatkan',
  list_suggestion: () => 'Cadangan',
  menu_stateLoading: () => 'Memuatkan',
  messageToast_allMessagesClosed: () => 'Semua mesej maklum balas ditutup.',
  message_close: () => 'Tutup',
  message_confirmation: () => 'Berjaya',
  message_error: () => 'Ralat',
  message_info: () => 'Maklumat',
  message_navigationFromMessagesRegion: () => 'Memasuki rantau mesej. Tekan F6 untuk navigasi.',
  message_navigationToMessagesRegion: () =>
    'Rantau mesej mengandungi mesej baru. Tekan F6 untuk menavigasi.',
  message_navigationToTouch: () => 'Rantau mesej mengandungi mesej baru.',
  message_warning: () => 'Amaran',
  noData_message: () => 'Tiada item untuk dipaparkan',
  overflowItemLabel: () => 'Lebih Banyak Tab',
  plural_separator: () => ', ',
  popup_close_skipLink: () => 'Ketik dua kali untuk menutup halaman timbul yang dibuka.',
  popup_liveRegion_F6_initial_focus_firstFocusable: () =>
    'Memasuki halaman timbul. Tekan F6 untuk menavigasi antara halaman timbul dengan kawalan yang berkaitan.',
  popup_liveRegion_F6_initial_focus_none: () =>
    'Halaman timbul dibuka. Tekan F6 untuk menavigasi antara halaman timbul dan kawalan yang berkaitan.',
  progressIndeterminate: () => 'Dalam Proses',
  radioButton_checked: () => 'Butang radio ditanda',
  radioButton_selected: () => 'Butang radio dipilih',
  radioButton_unchecked: () => 'Butang radio ditanda',
  radioButton_unselected: () => 'Butang radio tidak dipilih',
  radio_helpForRadio: () => 'Bantuan untuk butang radio',
  radio_requiredMessageDetail: () => 'Pilih nilai.',
  selectMultiple_apply: () => 'Gunakan',
  selectMultiple_back: () => 'Kembali',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_highlightSelectedTagsInstructionText: () =>
    'Gunakan kekunci anak panah ke kiri dan ke kanan untuk menyerlahkan nilai yang dipilih.',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Tekan Backspace atau Delete untuk mengalih keluar nilai yang dipilih.',
  selectMultiple_selectedValues: () => 'Nilai yang dipilih',
  selectMultiple_showSelectedValues: () => 'Tunjukkan nilai yang dipilih sahaja.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    p['VALUE_COUNT'] + ' nilai dipilih.',
  select_addToList: () => 'Tambah pada senarai',
  select_addToListAvailable: () => 'Tambah pada senarai tersedia',
  select_closeDropdown: () => 'Tekan Escape untuk tutup.',
  select_moreSearchOptions: () => 'Lebih banyak opsyen carian',
  select_moreSearchOptionsAvailable: () => 'Lebih banyak opsyen carian tersedia',
  select_noMatchesFound: () => 'Tiada padanan ditemui.',
  select_oneMatchFound: () => 'Satu padanan ditemui',
  select_requiredMessageDetail: () => 'Pilih nilai.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) => p['TOTAL_SIZE'] + ' padanan ditemukan',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' atau lebih padanan ditemukan',
  selectorAll_deselectAll: () => 'Nyahpilih semua',
  selectorAll_selectAll: () => 'Pilih semua',
  selector_selected: () => 'Kotak semak ditanda',
  selector_unselected: () => 'Kotak semak tidak ditanda',
  sheet_close: () => 'Tutup',
  switch_off: () => 'Mati',
  switch_on: () => 'Hidup',
  tabBarNavigationList_removeCueText: () => 'Boleh dialih keluar',
  tabBar_tabContainsErrors: () => 'Mengandungi ralat',
  tabbar_accAnnounceRemovedKey: (p: { itemKey: string }) => 'Dialih keluar ' + p['itemKey'],
  tabbar_labelContextMenu: () => 'mempunyai menu konteks',
  tabbar_labelMoveLeft: () => 'Alih ke Kiri',
  tabbar_labelMoveRight: () => 'Alih ke Kanan',
  tabbar_labelRemove: () => 'Alih Keluar',
  timeComponent_tooltipZoomIn: () => 'Zum Masuk',
  timeComponent_tooltipZoomOut: () => 'Zum Keluar',
  timeConverter_parseError: () => 'Masukkan masa yang lengkap.',
  train_current: () => 'Semasa',
  train_message_type: () => 'Jenis Mesej',
  train_not_visited: () => 'Tidak dilawati',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Langkah ' + p['currentStep'] + ' daripada ' + p['numberOfSteps'],
  train_visited: () => 'Dilawati',
  userAssistance_learnMore: () => 'Ketahui lebih lanjut',
  userAssistance_required: () => 'Diperlukan',
  vis_clearSelection: () => 'Kosongkan Pilihan',
  vis_drillable: () => 'Boleh Dalami',
  vis_invalidData: () => 'Data tidak sah',
  vis_labelAndValue: (p: { LABEL: string; VALUE: string }) => p['LABEL'] + ': ' + p['VALUE'],
  vis_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + ' daripada ' + p['totalCount'],
  vis_marqueeSelectTooltip: () => 'Pilihan marki',
  vis_marqueeZoomTooltip: () => 'Zum marki',
  vis_noData: () => 'Tiada data untuk dipaparkan',
  vis_panTooltip: () => 'Sorot',
  vis_stateCollapsed: () => 'Diruntuhkan',
  vis_stateExpanded: () => 'Dikembangkan',
  vis_stateLoaded: () => 'Dimuatkan',
  vis_stateLoading: () => 'Memuatkan',
  vis_stateSelected: () => 'Dipilih',
  vis_stateUnselected: () => 'Dinyahpilih',
  warn: () => 'Amaran'
};
export default bundle;
